import { createContext } from "react";
export var DownloadCenterContext = createContext({
    activeSubcategory: null,
    setActiveSubcategory: function () { return null; },
    downloads: {},
    setDownloads: function () { return null; },
});
